export default __webpack_public_path__ + "static/media/hit1.62057621.wav";